// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--w0wAJ","active":"a10a3f92e9--active--mwGtJ","focus-visible":"a10a3f92e9--focus-visible--MXtrR","text":"a10a3f92e9--text--oMJVB"};